<template>
	<ul class="tabs">
		<li v-for="(s, i) in scales"
			:key="s.key"
			:class="{ active: (s.key == scale.key) }"
			@click="setScale(s, i)">
			{{ s.name }}
		</li>
	</ul>
</template>

<script>

export default {

	props: {
		/**
		 * @prop 	scale
		 * @type 	Object
		 * @desc	Selected scale
		 * @required
		 */
		scale: {
			type: Object,
			required: true,
		},

		/**
		 * @prop 	scales
		 * @type 	Array
		 * @desc	Contains list of scale types
		 * @required
		 */
		scales: {
			type: Array,
			required: true,
		}
	},

	methods: {
		/**
		 * @function 	setScale
		 * @param 		{scale, index}
		 * @desc		emit the parent component's method with scale passed as an argument
		 */
		setScale(scale, index) {
			scale.index = index
			this.$emit('change', scale)
		}
	}
}
</script>

<style lang="scss" scoped>
ul.tabs {
    margin: 0px;
	padding: 0px;
	margin-bottom: 8px;
    border-bottom: 0.5px solid #ccc;

    li {
        cursor: pointer;
        display: inline-block;
        padding: 10px;
		padding-top: 15px;
        margin : 0px 25px;
        margin-bottom: -0.5px;
        font-size: 14px;
    }

    li.active {
        font-weight: 500;
        border-bottom: 2px solid;
    }
}
</style>
